import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingDiary\GetAccountingDiaryListController::__invoke
* @see app/Http/Controllers/AccountingDiary/GetAccountingDiaryListController.php
* @route '/api/accounting-diary'
*/
const GetAccountingDiaryListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingDiaryListController.url(options),
    method: 'get',
})

GetAccountingDiaryListController.definition = {
    methods: ["get","head"],
    url: '/api/accounting-diary',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountingDiary\GetAccountingDiaryListController::__invoke
* @see app/Http/Controllers/AccountingDiary/GetAccountingDiaryListController.php
* @route '/api/accounting-diary'
*/
GetAccountingDiaryListController.url = (options?: RouteQueryOptions) => {
    return GetAccountingDiaryListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingDiary\GetAccountingDiaryListController::__invoke
* @see app/Http/Controllers/AccountingDiary/GetAccountingDiaryListController.php
* @route '/api/accounting-diary'
*/
GetAccountingDiaryListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAccountingDiaryListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AccountingDiary\GetAccountingDiaryListController::__invoke
* @see app/Http/Controllers/AccountingDiary/GetAccountingDiaryListController.php
* @route '/api/accounting-diary'
*/
GetAccountingDiaryListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAccountingDiaryListController.url(options),
    method: 'head',
})

export default GetAccountingDiaryListController